import { render, staticRenderFns } from "./AssetsPlan.vue?vue&type=template&id=1f04d418&scoped=true&"
import script from "./AssetsPlan.vue?vue&type=script&lang=js&"
export * from "./AssetsPlan.vue?vue&type=script&lang=js&"
import style0 from "./AssetsPlan.vue?vue&type=style&index=0&id=1f04d418&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f04d418",
  null
  
)

export default component.exports